import { render, staticRenderFns } from "./OrganizationVehicle.vue?vue&type=template&id=0a401d51&scoped=true&"
import script from "./OrganizationVehicle.vue?vue&type=script&lang=js&"
export * from "./OrganizationVehicle.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationVehicle.vue?vue&type=style&index=0&id=0a401d51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a401d51",
  null
  
)

export default component.exports